import { IskljuceniOperater, Izvjestitelj } from "../../../index";
import { Card, CardContent, CardHeader } from "@mui/material";
import { useFormContext } from "react-hook-form";
import { VRSTA_ZAHTJEVA } from "../../../../enums";

const Index = () => {
  const { getValues } = useFormContext();
  const vrstaZahtjeva = getValues("vrstaZahtjeva");
  return (
    <Card variant={"outlined"} sx={{ mt: 3, position: "relative" }}>
      <CardHeader
        title={"Status operatera (Operator status)"}
        titleTypographyProps={{ variant: "h6" }}
      />
      <CardContent>
        {vrstaZahtjeva === "Registracija" && <Izvjestitelj />}
        {vrstaZahtjeva === "Isključenje" && <IskljuceniOperater />}
      </CardContent>
    </Card>
  );
};

export default Index;
